import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Button } from '../../atoms/button'

import {
  StyledContent,
  StyledInfoText,
  StyledIcon,
  StyledTextIconContainer,
  StyledCheckboxContainer,
} from './styles'
import { Checkbox } from '../../atoms/checkbox'
import { useTranslation } from '../../../context/translationProvider'

const TandcModal = (props) => {
  const { img, text, buttonText, onSubmit } = props
  const { translate } = useTranslation()
  const [acceptedPP, setAcceptedPP] = useState(false)
  const [acceptedTC, setAcceptedTC] = useState(false)

  return (
    <StyledContent>
      <StyledTextIconContainer>
        <StyledIcon src={img} />
        <StyledInfoText
          dangerouslySetInnerHTML={{
            __html: text,
          }}
        />
      </StyledTextIconContainer>

      <StyledCheckboxContainer>
        <Checkbox onChange={(e) => setAcceptedPP(e.target.checked)}>
          {translate('tandcModal.acceptPP')}
        </Checkbox>

        <Checkbox onChange={(e) => setAcceptedTC(e.target.checked)}>
          {translate('tandcModal.acceptTC')}
        </Checkbox>
      </StyledCheckboxContainer>

      <Button expand onClick={onSubmit} disabled={!acceptedPP || !acceptedTC}>
        {buttonText}
      </Button>
    </StyledContent>
  )
}

TandcModal.propTypes = {
  img: PropTypes.string,
  text: PropTypes.string,
  buttonText: PropTypes.string,
  onSubmit: PropTypes.func,
}

export { TandcModal }
